import React, { useEffect, useState } from 'react';
import { ColumnFilter } from '../../table/FilteringTable/ColumnFilter';
import { Form, Button, Dropdown, Modal, Row, Col, Spinner } from "react-bootstrap";
import { Add, DocumentDownload, More, Trash } from 'iconsax-react';
import TabellaLista from '../../Tabella/TabellaLista';
import MyApiClient from '../../../../api-client/MyApiClient';
import { format } from 'date-fns';
import notitles from "../../../../images/notitles.png";
import { segnalaMancanti } from "../../Util/campiMancanti";
import { apriFile } from '../../Util/anteprimaFile';
import { chiediConferma } from '../../Util/chiediConferma';
import { MAX_FILE_CARICATO, messaggioFileTroppoGrande } from '../../Util/limiteFile';

export const FormTitoli = (props) => {

	const MAX_FILE_SIZE = MAX_FILE_CARICATO;
	const ALLOWED_FILE_TYPES = ['application/pdf'];

	const [newTitleName, setNewTitleName] = useState('');
  	const [newTitleFile, setNewTitleFile] = useState(null);

	const [data_json, setDataJson] = useState(null);
	const [modalCentered, setModalCentered] = useState(false);

	const [modalShowed, setModalShowed] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [modalText, setModalText] = useState('');

	const [loadingShowed, setLoadingShowed] = useState(false);

	const handleTextChange = (event) => {
		setNewTitleName(event.target.value);
	};

	const handleFileChange = (event) => {
		setNewTitleFile(event.target.files[0]);
	};

	const data_column = [
		{
			Header: 'Data di caricamento',
			accessor: 'date',
			Filter: ColumnFilter
		},
		{
			Header: 'Nome',
			accessor: 'name',
			Filter: ColumnFilter
		},
		{
			Header: 'Azione',
			Footer: 'Azione',
			accessor: 'azione',
			Cell: ({ row }) => {
				return (
					<Dropdown drop="auto">
						<Dropdown.Toggle
							className="btn-primary light sharp i-false btn-action"
						>
							<More />
						</Dropdown.Toggle>
						<Dropdown.Menu>
							<Dropdown.Item onClick={() => downloadTitle(row.original)} className="text-danger"><span className="me-2"><DocumentDownload size="20" /></span>Visualizza</Dropdown.Item>
							{!props.isDisabled && <Dropdown.Item onClick={() => deleteTitle(row.original)} className="text-danger"><span className="me-2"><Trash size="20" /></span>Elimina</Dropdown.Item>}
						</Dropdown.Menu>
					</Dropdown>
				)
			},
			disableFilters: true,
		},
	];

	function updateTitlesTable(club_titles) {

		if (!Array.isArray(club_titles)) {
			setDataJson([]);
			return;
		}

		const updatedDataJson = club_titles.map((title, index) => {
			return {
				'id': title.document.id,
				'name': title.document.name,
				'uri': title.document.uri,
				'date': format(title.document.uploadedAt, 'dd/MM/yyyy HH:mm:ss')
			};
		});
		setDataJson(updatedDataJson);
	}

	useEffect(() => {
		if (props.profile && props.profile.club && props.profile.club.titles) {	
            updateTitlesTable(props.profile.club.titles);
        } else {
            setDataJson(null);
        }
    }, [props]);

	// PDF e immagini si vedono nella finestra di anteprima, senza scaricarli (set-ui anteprima-file)
	const downloadTitle = (row) => {
        apriFile({ uri: row.uri, nome: row.name || row.nome || row.title || '' });
    };

	const deleteTitle = async (row) => {
		if (!(await chiediConferma({ titolo: 'Eliminare il titolo?', testo: `Il titolo «${row.name || ''}» viene eliminato dalla struttura.`, conferma: 'Elimina' }))) return;
		continueDeleteTitle(row);
    };

	const continueDeleteTitle = (row) => {

		const deleteData = async () => {
            try {
                const tokenDetailsString = sessionStorage.getItem('userDetails');
                if (tokenDetailsString) {
                    const tokenDetails = JSON.parse(tokenDetailsString);
                    const token = tokenDetails.idToken;
                    const apiClient = new MyApiClient();

					setLoadingShowed(true);
                    const saveResult = await apiClient.deleteTitle(token, row.id);
					setLoadingShowed(false);

                    if(!saveResult) {
                        setModalTitle("Errore durante l'operazione");
                        setModalText("Si è verificato un errore durante l'eliminazione ("+saveResult.error+")");
                        setModalShowed(true);
                    } else if (props.superAdmin) {
						props.onSalvato?.();
                    } else {
						window.location.href = '/struttura/lamiastruttura?tab=titoli';
                    }
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        deleteData();
	};

	const addTitle = (e) => {
        e.preventDefault();

		const mancanti = [];
		if(newTitleName.trim()==='') {
			mancanti.push({ campo: 'titolo-nome', messaggio: 'Manca il nome del titolo' });
		}

		let file = newTitleFile;

		if(!file) {
			mancanti.push({ campo: 'titolo-file', messaggio: 'Manca il file del titolo' });
		} else if (file.size > MAX_FILE_SIZE) {
			mancanti.push({ campo: 'titolo-file', messaggio: messaggioFileTroppoGrande(file) });
		} else if (!ALLOWED_FILE_TYPES.includes(file.type)) {
			mancanti.push({ campo: 'titolo-file', messaggio: 'Il file deve essere in formato PDF (dimensione massima 4 MB)' });
		}

		if (segnalaMancanti(mancanti) > 0) return;

		setModalCentered(false);

		if (file) {

			const reader = new FileReader();
			reader.onloadend = () => {
				const base64String = reader.result.split(',')[1];
				// console.log(base64String);
				continueAddTitle(newTitleName,base64String);
			};
			reader.readAsDataURL(file);
		}
    };

	function continueAddTitle(newTitleName,base64String) {
		//console.log(newTitleName);
		//console.log(base64String);

		const addData = async () => {
            try {
                const tokenDetailsString = sessionStorage.getItem('userDetails');
                if (tokenDetailsString) {
                    const tokenDetails = JSON.parse(tokenDetailsString);
                    const token = tokenDetails.idToken;
                    const apiClient = new MyApiClient();

					let data_update = {
						'document': {
							'content': base64String,
							'name': newTitleName
						}
					}
					
					setLoadingShowed(true);
                    const saveResult = await apiClient.addTitle(token, data_update);
					setLoadingShowed(false);

                    if(!saveResult) {
                        setModalTitle("Errore durante l'operazione");
                        setModalText("Si è verificato un errore durante il salvataggio ("+saveResult.error+")");
                        setModalShowed(true);
                    } else if (props.superAdmin) {
						props.onSalvato?.();
                    } else {
						window.location.href = '/struttura/lamiastruttura?tab=titoli';
                    }
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        addData();
	}

	return (
		<>
			<Modal className="fade" show={loadingShowed} centered>
				<Modal.Body className="text-center">
				<Spinner animation="border" role="status">
					<span className="sr-only">Loading...</span>
				</Spinner>
				<div>Caricamento in corso...</div>
				</Modal.Body>
			</Modal>

			<Modal className="fade" show={modalShowed} centered>
                <Modal.Header>
                    <Modal.Title>{modalTitle}</Modal.Title>
                    <Button onClick={() => setModalShowed(false)} variant="" className="btn-close">
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <Row><Col className="col-xl-64">{modalText}</Col></Row>
                </Modal.Body>
                <Modal.Footer className="justify-content-between">
                    <Button className="btn btn-primary btn-add" onClick={() => setModalShowed(false)}>
                        Chiudi
                    </Button>
                </Modal.Footer>
            </Modal>

			<Modal className="fade" show={modalCentered} centered>
				<Modal.Header>
					<Modal.Title>Aggiungi titolo federale</Modal.Title>
					<Button
						onClick={() => setModalCentered(false)}
						variant=""
						className="btn-close"
					>
					</Button>
				</Modal.Header>
				<Modal.Body>
					<Form>
						<Row>
							<Col className="col-lg-12 pb-4">
								<Form.Label htmlFor="titolo-nome">Nome del titolo *</Form.Label>
								<Form.Control id="titolo-nome" type="text" placeholder="Inserisci il nome del titolo" onChange={handleTextChange} />
							</Col>
						</Row>
						<Row>
							<Col className="col-lg-12 pb-4">
								<Form.Label htmlFor="titolo-file">Seleziona file *</Form.Label>
								<Form.Control id="titolo-file" type="file" placeholder="Carica il file" onChange={handleFileChange} />
							</Col>
						</Row>
					</Form>
				</Modal.Body>
				<Modal.Footer className="justify-content-between">
					<Button className="btn btn-light btn-add" onClick={() => setModalCentered(false)}>
						Annulla
					</Button>
					<Button onClick={addTitle} className="btn btn-primary btn-add">Aggiungi</Button>
				</Modal.Footer>
			</Modal>

			{/* `soloEsistenti`: i titoli non si registrano piu' (si caricano i Documenti); restano visibili quelli gia' caricati */}
			{data_json && data_json.length === 0 && !props.soloEsistenti &&
				<center>
					<div>
						<img src={notitles} style={{width: '50%'}} alt="" />
					</div>
					<div style={{ fontSize: '26px', color: 'grey', marginTop: '30px'}}>
						Nessun titolo inserito
					</div>
					<div style={{ fontSize: '16px', color: 'grey', fontWeight: '300', marginTop: '20px'}}>
						Non hai ancora inserito nessun titolo
						<br></br>
						Inizia adesso e aggiungi il tuo primo titolo per vedere il dettaglio qui.
					</div>
					<div>
						{!props.isDisabled && <Button style={{ marginTop: '20px'}} onClick={() => setModalCentered(true)} className="btn btn-primary btn-sm btn-add" ><Add variant="Bulk" /><span className='ms-2'>Aggiungi</span></Button>}
					</div>
				</center>
			}
			
			{data_json && data_json.length>0 &&
				<TabellaLista
					cardTitle={props.soloEsistenti ? 'Titoli già caricati' : 'Lista Titoli'}
					hasSearch={false}
					hasFilter={false}
					data_column={data_column}
					data_json={data_json}
					hasAddMoreAsModal={!(props.isDisabled || props.soloEsistenti)}
					modalCallBack={() => setModalCentered(true)}
				/>
			}
		</>
	)

}
export default FormTitoli;